export enum TipoDadoEnum {
  Int = 1,
  Decimal = 2,
  String = 3,
  Date = 4,
  Boolean = 5
}